export const IMAGE_URL = 'https://cdn.toolo.in';
